export const enum EntryMode {
    Create  = 1,
    Edit    = 2,
    Display = 0,
}
export interface CrossCountryEntry {
    id              : number,
    sourceCountryId : number,
    sourceCountry   : string,
    targetCountryId : number,
    targetCountry   : string,
    refundRate      : number
}
export interface PutCrossCountryEntry {
    id              : number,
    sourceCountryId : number,
    targetCountryId : number,
    refundRate      : number,   
    mode            : EntryMode
}

export interface CountryTable {
    id         : number,
    name       : string,
    description: string,
    countrySet : CrossCountryEntry[]
}
export interface PostCountryTable {
    name        : string,
    description : string,
    countrySet  : PutCrossCountryEntry[] 
}
export interface PutCountryTable {
    id          : number,
    name        : string,
    description : string,
    countrySet  : PutCrossCountryEntry[]
}